export const initialState = {
    items: null,
    isLoading: false,
    isPatching: false,
    error: null,
};
